<template>
  <div>
    <div class="">
      <div class="pull-right mb-2 mt-4" v-if="event.bookings.length">
        <small>Last ned deltakerlister: </small>
        <a
          href="#"
          @click.prevent="exportBookings('csv')"
          class="btn btn-sm btn-primary mr-1"
          download
        >
          <i class="fa fa-file-code-o"></i> CSV</a
        >
        <a
          href="#"
          @click.prevent="exportBookings('xlsx')"
          class="btn btn-sm btn-primary mr-1"
          download
        >
          <i class="fa fa-file-excel-o"></i> Excel</a
        >
      </div>
    </div>
    <b-table
      v-if="event.bookings.length"
      stacked="lg"
      striped
      hover
      :fields="bookingFields"
      :items="event.bookings"
    >
      <template slot="name" slot-scope="{ item }">
        {{ item.booking_details[0].value }}
        {{ item.booking_details[1].value }}
      </template>
      <template slot="email" slot-scope="{ item }">
        {{ item.booking_details[2].value }}
      </template>
      <template slot="phone" slot-scope="{ item }">
        {{ item.booking_details[3].value }}
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['event', 'selectedDate'],
  computed: {
    ...mapGetters({
      dates: 'bookings/availableDates',
    }),
  },
  data() {
    return {
      sDate: null,
      rootUrl: process.env.VUE_APP_API_URL,
      bookingFields: [
        // A column that needs custom formatting
        { key: 'name', label: 'Navn' },
        // A regular column
        { key: 'email', label: 'E-postadresse' },
        // A virtual column made up from two fields
        { key: 'phone', label: 'Telefonnummer' },
        { key: 'code', label: 'Verdibevisnummer' },
      ],
      changeParticipants: false,
      newParticipants: this.event.participants,
    };
  },
  methods: {
    exportBookings(method) {
      this.sDate = this.dates.find(d => d.id === this.selectedDate);
      const url = `${this.rootUrl}/bookings/${this.sDate.id}/export/${method}`;
      axios.get(url, { responseType: 'arraybuffer' }).then(response => {
        var blob = new Blob([response.data], {
          type:
            method == 'xlsx'
              ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              : 'text/csv',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.sDate.start.replace(' ', '_')}-${this.sDate.title
          .replace('of', 'av')
          .replace(' ', '_')}`;
        link.click();
      });
    },
  },
};
</script>